// Global Instructions Rule Applied!
// Grid row shape returned by view__journal_entries: every journal entry on
// the funds' books - manual entries (spec A3.5) and the lines each source
// (fund / asset transaction, year-end close, ...) wrote on one fund.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const JournalEntryRecordSchema = z
  .object({
    // set only on rows the journal entry editor opens
    journal_entries__id: z.string().nullish(),
    prog__row_key: z.string(),
    prog__source_kind: z.string(),
    prog__source: z.string(),
    // the form a row opens (table + id); null = the source has no form
    prog__record_table: z.string().nullish(),
    prog__record_id: z.string().nullish(),
    funds__id: z.string(),
    funds__name: z.string(),
    journal_entries__entry_date: z.string(),
    journal_entries__entry_date_fmt: z.string().nullish(),
    journal_entries__description: z.string().nullish(),
    cfg_transaction_statuses__id: z.number().nullish(),
    cfg_transaction_statuses__label: z.string().nullish(),
    journal_entries__total_debits: z.number(),
    journal_entries__total_debits_fmt: z.string().nullish(),
    journal_entries__line_count: z.number(),
    journal_entries__is_balanced: z.boolean(),
    prog__linked_to: z.string().nullish()
  })
  .strict()

export type JournalEntryRecord = z.infer<typeof JournalEntryRecordSchema>

export const JournalEntryRecordFields = Object.fromEntries(
  Object.keys(JournalEntryRecordSchema.shape).map((k) => [k, k])
) as Record<keyof typeof JournalEntryRecordSchema.shape, string>

export function validateJournalEntryRecord(data: unknown, isArray: true): JournalEntryRecord[]
export function validateJournalEntryRecord(data: unknown, isArray?: false): JournalEntryRecord
export function validateJournalEntryRecord(data: unknown, isArray?: boolean): JournalEntryRecord | JournalEntryRecord[]
export function validateJournalEntryRecord(data: unknown, isArray = false): JournalEntryRecord | JournalEntryRecord[] {
  try {
    return validateWithZodSchema(JournalEntryRecordSchema, data, 'journal entry record', { isArray })
  } catch (error) {
    throw new Error(`Journal entry validation failed: ${error}`)
  }
}
